import React from 'react';
import * as S from './srp-card-ui.styles';
import CarrierSprite from '@stencil/carrier-sprite';
import { spriteClasses } from '@stencil/flights-constants/src/text';
import CarrierLogo from '../../Common/CarrierLogo';

// const getLayoverText = flights => {
//   const carrierNameText = `${flights
//     .slice(1)
//     .map(f => `${f.depText} ${f.layoverInfo}`)
//     .join(', ')}`;
//   return `Layover${flights.length > 2 ? 's' : ''} - ${carrierNameText}`;
// };

const Route = ({ flightItem }) => {
  const { flightArr, arrivalDetails, carrierLogoArr, carrierNameArr, duration } = flightItem;
  const {
    arrCode = '',
    arrTime = '',
    arrText = '',
    arrCountry = '',
    arrDayDiff
  } = arrivalDetails || {};

  const hasLayover = flightArr && flightArr.length > 1 ? true : false;
  const viaText =
    flightArr && flightArr.length > 1
      ? `${flightArr
          .slice(1)
          .map(f => f.depCode)
          .join(' - ')}`
      : '';
  return (
    <div className="width100 flexCol ">
      <div className="dF alignItemsCenter">
        {/* <span>logo</span>  */}
        {carrierLogoArr &&
          carrierLogoArr.map((carrierCode, index) =>
            spriteClasses.indexOf(`carrier${carrierCode}`) > -1 ? (
              <CarrierSprite key={index} className={`carrier${carrierCode}`} />
            ) : (
              <CarrierLogo
                key={index}
                src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${carrierCode}.png`}
                alt="carrier_logo"
              />
            )
          )}
        {/* <S.CarrierLogo src="https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/6E.png" /> */}
        <span className="font14">
          {carrierNameArr ? (carrierNameArr.length > 1 ? 'Multi-Airline' : carrierNameArr[0]) : ''}
        </span>
      </div>
      <div className="dF width100 padT10 alignItemsEnd padB5">
        <S.Dep className="flexCol">
          <div className="greyCntLt">
            <span className="txtUpper greyCnt">{flightArr && flightArr[0].depCode}</span>{' '}
            <span>{flightArr && flightArr[0].depText}</span>
            <span>{`, ${flightArr && flightArr[0].depCountry}`}</span>
          </div>
          <S.Time className="padT10 f600">{flightArr && flightArr[0].depTime}</S.Time>
        </S.Dep>

        <S.Dur className="flexCol alignItemsCenter">
          {hasLayover ? (
            <div className="dF justifyCenter greyCnt padB5">
              <span>-</span>
              <span>
                <S.Lcity className="txtUpper">{viaText}</S.Lcity>
                <span>-</span>
              </span>
            </div>
          ) : (
            <span>&nbsp;</span>
          )}
          <S.DurTime className="f500 padT10">{duration}</S.DurTime>
        </S.Dur>

        <S.Space></S.Space>
        <S.Arr className="flexCol">
          <div className="greyCntLt">
            <span className="txtUpper greyCnt">{arrCode}</span> <span>{arrText}</span>
            <span>{`, ${arrCountry}`}</span>
          </div>
          <div className="dF alignItemsCenter">
            <S.Time className="f500  padT10">{arrTime}</S.Time>
            {arrDayDiff > 0 ? <sup className="red padL5 f500">&#43;{arrDayDiff}D</sup> : null}
          </div>
        </S.Arr>
      </div>
      {/* {hasLayover ? (
        <div className="padT5 padB10 greyCnt">{getLayoverText(flightArr)}</div>
      ) : (
        <div className="padT5 padB10 greyCnt">&nbsp;</div>
      )} */}
    </div>
  );
};

export default Route;
